/**
 * norse-countdown.js
 * Evergreen deal countdown timer — persists in localStorage.
 * Resets only when the stored end-time expires (new countdown = now + duration).
 */
(function () {
  function pad(n) {
    return String(Math.floor(n)).padStart(2, '0');
  }

  function formatTime(totalSeconds) {
    const h = Math.floor(totalSeconds / 3600);
    const m = Math.floor((totalSeconds % 3600) / 60);
    const s = totalSeconds % 60;
    return pad(h) + ':' + pad(m) + ':' + pad(s);
  }

  function initCountdown(el) {
    const blockId  = el.dataset.blockId;
    const duration = parseInt(el.dataset.duration, 10);
    const timerEl  = el.querySelector('.norse-countdown__timer');
    if (!timerEl || !blockId || !duration) return;

    const lsKey = 'norse_countdown_' + blockId;
    const now   = Date.now();
    let endTime = parseInt(localStorage.getItem(lsKey) || '0', 10);

    if (!endTime || endTime <= now) {
      endTime = now + duration * 1000;
      try { localStorage.setItem(lsKey, String(endTime)); } catch (_) {}
    }

    let intervalId;

    function tick() {
      const remaining = Math.max(0, Math.floor((endTime - Date.now()) / 1000));
      timerEl.textContent = formatTime(remaining);

      if (remaining <= 0) {
        clearInterval(intervalId);
        // Remove stored key so next visit starts fresh
        try { localStorage.removeItem(lsKey); } catch (_) {}
        el.style.display = 'none';
      }
    }

    tick();
    intervalId = setInterval(tick, 1000);
  }

  function attachAll() {
    document.querySelectorAll('.norse-countdown[data-block-id]').forEach(function (el) {
      if (!el._norseCountdownInit) {
        el._norseCountdownInit = true;
        initCountdown(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachAll);
  } else {
    attachAll();
  }
})();
